<script lang="ts">
import SectionCheckWaitedList from '@/generated/sections/SectionCheckWaitedList.vue';
import { TransactionTypes, TransactionStatuts } from '@/generated/classes/Transaction';
import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
import Transaction from '@/extend/classes/Transaction';
import Section from '@/framework/base/classes/Section';
import SectionCheckReceived from '@/extend/sections/SectionCheckReceivedExtend.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SectionCheckWaitedList,
    data() {
        return {
            transaction: new Transaction()
        };
    },
    computed: {
        headers() {
            return [
                { text: "Date de demande", value: 'dateTransaction', cellClass: '', sortable: true },
                { text: "Emetteur", value: 'ownerLabel', cellClass: '', sortable: true },
                { text: "Référence", value: 'reference', cellClass: '', sortable: true },
                { text: "Montant", value: 'amount', cellClass: '', sortable: true },
                { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
            ];
        },
        canAdd(): boolean {
            return false;
        },
        section(): Section {
            const section = new Section();
            section.component = SectionCheckReceived;
            section.ressource = this.ressource;
            section.picto = 'SectionIdentitePicto';
            section.data = this.transaction;
            section.type = 'transaction';
            section.autoSave = false;
            return section;
        }
    },
    methods: {
        canUpdate(transaction: Transaction): boolean {
            return true;
        },
        defaultFilter(): void {
            {
                const columnFilter = new ColumnFilter();
                columnFilter.name = "type";
                columnFilter.staticFilter = true;
                const choix = new ListChoix();
                choix.value = TransactionTypes.CHEQUE_RECU;
                columnFilter.filters.push(choix);
                this.activeFilters.push(columnFilter);
            }
            {
                const columnFilter = new ColumnFilter();
                columnFilter.name = "statut";
                columnFilter.staticFilter = true;
                const choix = new ListChoix();
                choix.value = TransactionStatuts.WAITED;
                columnFilter.filters.push(choix);
                this.activeFilters.push(columnFilter);
            }
        },
        updateItem(item: unknown): void {
            this.transaction.fromTransaction(item as Transaction);
            this.transaction.canUpdate = true;
            this.dialogOpen = true;
        }
    }
})

</script>
